<template>
  <div
    id="map"
    ref="map"
    v-on:mouseenter="mouseover = true"
    v-on:mouseleave="mouseover = false"
  >
    <div class="mapboxgl-ctrl-top-left">
      <div class="col_1_2 controls">
        <div class="name">
          <ShortcutSelect
            v-bind:namesFromGeotype="namesFromGeotype"
            v-bind:geotypesForMap="['county', 'mcd', 'SchoolDistrict', 'ISD', 'CensusTract', 'BlockGroup']"
            v-bind:geotype="geotype"
            v-on:set-geo-type="setGeoType($event)"
          />
        </div>
        <div style="margin-left: 36px;">
          <span style="margin-left: 5px; margin-right: 3px; font-weight: bolder; font-size: 1.2em;">   is   </span>
          <select style="font-weight: bolder; font-size: 1.1em;" class='comm_dropdown' v-on:change="setSelected(+$event.target.value)">
            <option disabled value="">Choose a Community</option>
            <option
              v-bind:value="8999"
              v-bind:selected="!selectedId"
            >Southeast Michigan
            </option>
            <option
              v-for="id in mcdIds"
              v-bind:key="id"
              v-bind:value="id"
              v-bind:selected="selectedId===id"
            >{{ namesForSelectedType.get(id)[0].replace('Block Group', 'BG').replace('Census Tract', 'Tract')}}
            </option>
          </select>
        </div>
      </div>
      <div class="map_layers">
        <div style="border-left: black 1px solid;border-right: black 1px solid; padding: 2px">
          <div>
            <select class='layer_dropdown' v-model="selectedLayers.fillPoly">
              <option disabled value="">Choose a Layer</option>
              <option value="">None</option>
              <optgroup label="Availability Layers">
                <option value="bbspeed_fill_0">Broadband speed available</option>
                <option value="num_prov_raster_0">Number of broadband providers</option>
              </optgroup>
              <optgroup label="Usage Layers">
                <option value="blockgroups_fill_0">Households not using broadband</option>
                <option value="withcomp_fill_0">Households with no computer</option>
              </optgroup>
            </select>
          </div>
          <CategoricalLegend
            v-if="loaded && selectedLayers.fillPoly === 'num_prov_raster_0'"
            v-bind:colorLegendData="providersColorLegendData"/>
          <CategoricalLegend
            v-if="loaded && selectedLayers.fillPoly === 'bbspeed_fill_0'"
            v-bind:colorLegendData="bbspeedColorLegendData"
            v-on:filterChange="setLegendFilter('bbspeedColorLegendData', $event)"/>
          <colerLegend
            v-if="loaded && colorLegendData && colorLegendData.length && legendMarks && legendMarks.length && (selectedLayers.fillPoly === 'blockgroups_fill_0' || selectedLayers.fillPoly === 'withcomp_fill_0')"
            v-bind:colorLegendData="colorLegendData"
            v-bind:format="formatPercentOnLegend"
            v-bind:legendMarks="legendMarks"/>
        </div>
        <div style="border-right: black 1px solid; padding: 2px">
          <select class='layer_dropdown' v-model="selectedLayers.overlays" v-bind:disabled="zoom >= 12">
            <option disabled value="">Choose a Demographic Overlay</option>
            <option value="">None</option>
            <option value="dot_dens_race_circle_0">{{race_per_dot}} person/dot not using broadband by race/ethnicity
            </option>
            <option value="dot_dens_income_circle_0">{{income_per_dot}} household/dot not using broadband by income
            </option>
          </select>
          <CategoricalDotLegend
            v-if="loaded && selectedLayers.overlays === 'dot_dens_race_circle_0'"
            v-bind:colorLegendData="dotDensRaceColorLegendData"
            v-on:filterChange="setLegendFilter('dotDensRaceColorLegendData', $event)"/>
          <ColorDotLegend
            v-if="loaded && selectedLayers.overlays === 'dot_dens_income_circle_0'"
            v-bind:colorLegendData="dotDensIncomeColorLegendData"
            v-bind:format="(a => a)"
            v-bind:legendMarks="dotDensIncomelegendMarks"
            v-on:filterChange="setLegendFilter('dotDensIncomeColorLegendData', $event)"/>
        </div>
        <div>
          <div
            v-on:click="hotspotVisibility = !hotspotVisibility"
          >
            <input v-model="hotspotVisibility"
                   type="checkbox"
            >
            WiFi Hotspots
          </div>
          <div
            v-on:click="schoolsVisibility = !schoolsVisibility"
          >
            <input v-model="schoolsVisibility"
                   type="checkbox"
            >
            Schools
          </div>
        </div>
      </div>
    </div>
    <div id="basemap" class="mapboxgl-ctrl-top-right">
      <div
        class="mapbox-ctrl mapboxgl-ctrl-group basemaps">
        <BaseMapSelect v-on:style-change="setMapStyle($event)"/>
      </div>
    </div>
    <div id="homeExtent" class="mapboxgl-ctrl-top-left">
      <div
        v-on:click="setSelectedtoRegion()"
        class="mapbox-ctrl mapboxgl-ctrl-group">
        <button class="mapboxgl-ctrl-icon" type="button" title="Reset to Region">
          <font-awesome-icon icon="home"/>
        </button>
      </div>
    </div>
    <div id="AutoZoom" class="mapboxgl-ctrl-top-left">
      <div
        class="mapbox-ctrl mapboxgl-ctrl-group basemaps">
        <AutoZoom
          v-on:autoZoom="autoZoom=$event"
        />
      </div>
    </div>
    <div ref="mapgl" v-on:mouseleave="setHover(null)"></div>
    <MapboxLayer
      name="communities"
      v-bind:geoJSON="communitiesGeoJSON"
      v-bind:layers="blankGeo"
      v-bind:interactivity=true
      v-bind:before-layer-name=beforeLayers
      v-on:featureClick="communityClick($event)"
      v-on:featureMouseMove="communityHover($event)"
      v-on:featureMouseLeave="setHover(null)"
    />
    <MapboxLayer
      name="blockgroups"
      url="mapbox://semcog.a3hupy6c"
      v-bind:layers='communitiesLayer'
      v-bind:before-layer-name=beforeLayers
    />
    <MapboxLayer
      name="num_prov"
      url="https://tiles.arcgis.com/tiles/R0IGaIgf2sox9aCY/arcgis/rest/services/MI_Density_of_Providers_by_Area_25M3M_2021_09_30/MapServer/WMTS/tile/1.0.0/MI_Density_of_Providers_by_Area_25M3M_2021_09_30/default/default028mm/{z}/{y}/{x}.png"
      v-bind:layers="num_prov"
      v-bind:rasterFlag=true
      v-bind:before-layer-name=beforeLayers
    />
    <MapboxLayer
      name="bbspeed"
      url="mapbox://semcog.bi6tguxp"
      v-bind:layers="bbspeed"
      v-bind:before-layer-name=beforeLayers
    />
    <MapboxLayer
      name="dot_dens_race"
      url="mapbox://semcog.cf3o2ebp"
      v-bind:layers="dot_dens_race"
      v-bind:before-layer-name=beforeLayers
    />
    <MapboxLayer
      name="dot_dens_income"
      url="mapbox://semcog.1s5ivefg"
      v-bind:layers="dot_dens_income"
      v-bind:before-layer-name=beforeLayers
    />
    <ArcRestLayer
      name="hotspot_data"
      v-bind:restURL="
      'https://services.arcgis.com/R0IGaIgf2sox9aCY/ArcGIS/rest/services/'+
      'MI_HotspotData_serviceByConnectedNation/FeatureServer/0/query?'+
      'where=1%3D1&'+
      'objectIds=&time=&'+
      'geometry=%7B%22rings%22%3A%5B%5B%5B-82.497701%2C43.152532%5D%2C%5B-82.503158%2C43.168951%5D%2C%5B-82.996248%2C43.1541%5D%2C%5B-82.983637%2C42.893742%5D%2C%5B-83.689376%2C42.871264%5D%2C%5B-83.686485%2C42.783264%5D%2C%5B-84.158183%2C42.776639%5D%2C%5B-84.13113%2C42.424567%5D%2C%5B-84.131958%2C42.071576%5D%2C%5B-83.773916%2C42.082428%5D%2C%5B-83.76313%2C41.723541%5D%2C%5B-83.482809%2C41.732184%5D%2C%5B-83.22967529296874%2C41.947234477977766%5D%2C%5B-82.496337890625%2C42.61981257367216%5D%2C%5B-82.418396%2C42.974813%5D%2C%5B-82.426531%2C43.017243%5D%2C%5B-82.497701%2C43.152532%5D%5D%5D%2C%22spatialReference%22%3A%7B%22wkid%22%3A4326%7D%7D&'+
      'geometryType=esriGeometryPolygon&'+
      'inSR=&'+
      'spatialRel=esriSpatialRelIntersects&'+
      'resultType=standard&'+
      'distance=14.0&'+
      'units=esriSRUnit_Meter&'+
      'returnGeodetic=false&'+
      'outFields=&'+
      'returnGeometry=true&'+
      'featureEncoding=esriDefault&'+
      'multipatchOption=xyFootprint&'+
      'maxAllowableOffset=&'+
      'geometryPrecision=&'+
      'outSR=&'+
      'datumTransformation=&'+
      'applyVCSProjection=false&'+
      'returnIdsOnly=false&'+
      'returnUniqueIdsOnly=false&'+
      'returnCountOnly=false&'+
      'returnExtentOnly=false&'+
      'returnQueryGeometry=false&'+
      'returnDistinctValues=false&'+
      'cacheHint=false&'+
      'orderByFields=&'+
      'groupByFieldsForStatistics=&'+
      'outStatistics=&'+
      'having=&'+
      'resultRecordCount=&'+
      'returnZ=false&'+
      'returnM=false&'+
      'returnExceededLimitFeatures=true&'+
      'quantizationParameters=&'+
      'sqlFormat=none&'+
      'f=pgeojson&'+
      'token='
      "
      v-bind:layers="hotspot_data"
      v-bind:before-layer-name=beforeLayers
    />
    <ArcRestLayer
      name="schools"
      v-bind:restURL="
      'https://gisagocss.state.mi.us/arcgis/rest/services/CSS/Schools_Districts/MapServer/0/query?where=COUNTY+IN+%28%27OAKLAND%27%2C+%27WAYNE%27%2C+%27ST.+CLAIR%27%2C+%27WASHTENAW%27%2C+%27MACOMB%27%2C+%27MONROE%27%2C+%27LIVINGSTON%27%29&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=OFFICIALNM&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&having=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultRecordCount=&queryByDistance=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson'
      "
      v-bind:layers="schools"
      v-bind:before-layer-name=beforeLayers
    />
    <Loader v-if="!loaded"/>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce'
  import mapboxgl from 'mapbox-gl'
  import * as d3 from 'd3'
  import ShortcutSelect from './map/ShortcutSelect'
  import MapboxLayer from './map/MapboxLayer'
  import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
  import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
  import cartocolor from 'cartocolor'
  import * as turf from 'turf'
  import Loader from './map/Loader'
  import BaseMapSelect from "./map/BaseMapSelect";
  import AutoZoom from "./map/AutoZoom";
  import { naturalBreaks } from './map/NaturalBreaks'
  import CategoricalLegend from "./map/CategoricalLegend";
  import CategoricalDotLegend from "./map/CategoricalDotLegend";
  import ColerLegend from "./map/ColerLegend";
  import ColorDotLegend from "@/components/map/ColorDotLegend";
  import ArcRestLayer from '@/components/map/ArcRestLayer'

  export default {
  name: 'MainMap',
  components: {
    ArcRestLayer,
    ColorDotLegend,
    BaseMapSelect, Loader, ShortcutSelect, MapboxLayer, CategoricalLegend, CategoricalDotLegend, ColerLegend, AutoZoom},
  props: [
    'geotype',
    'allGeojsonByType',
    'selectedId',
    'hoverId',
    'getIndMoeName',
    'namesFromGeotype',
    'namesForSelectedType',
  ],
  data: function () {
    return {
      idsInViewport: new Map(),
      selectedLayers: {
        'overlays': '',
        'fillPoly': 'bbspeed_fill_0',
      },
      loaded: false,
      mouseover: false,
      overrideClassification: null,
      hotspotVisibility: false,
      schoolsVisibility: false,
      autoZoom: true,
      zoom: 0,
      dotDensRaceColorLegendData: [
        {//#5F4690,#1D6996,#38A6A5,#0F8554,#73AF48,#EDAD08,#E17C05,#CC503E,#94346E,#6F4070,#994E95,#666666
          key: 'hhpopnhwhite_nobb_21',
          value: '#0F8554',
          visibility: true,
          label: 'White',
        },
        {
          key: 'hhpopblk_nobb_21',
          value: '#EDAD08',
          visibility: true,
          label: 'Black',
        },
        {
          key: 'hhpophisp_nobb_21',
          value: '#CC503E',
          visibility: true,
          label: 'Hispanic',
        },
        {
          key: 'hhpopasian_nobb_21',
          value: '#94346E',
          visibility: true,
          label: 'Asian',
        }],
      dotDensIncomeColorLegendData:
        [
          {//#fcde9c,#faa476,#f0746e,#e34f6f,#dc3977,#b9257a,#7c1d6f
            key: 'hhlessthan20000_nobb_21',
            value: '#0a021f',
            visibility: true,
            label: '<20',
          },
          {
            key: 'hh_20000to34999_nobb_21',
            value: '#51127C',
            visibility: true,
            label: '20to34',
          },
          {
            key: 'hh_35000to49999_nobb_21',
            value: '#e34f6f',
            visibility: true,
            label: '35to49',
          },
          {
            key: 'hh_50000to74999_nobb_21',
            value: '#faa476',
            visibility: true,
            label: '50to74',
          },
          {
            key: 'hh_75000ormore_nobb_21',
            value: '#fcde9c',
            visibility: true,
            label: '>75',
          }],
      providersColorLegendData:
        [
          {
            key: 0,
            value: '#ffffff',
            visibility: true,
            label: '0',
          },
          {
            key: 1,
            value: '#ffff80',
            visibility: true,
            label: '1',
          },
          {
            key: 2,
            value: '#bde670',
            visibility: true,
            label: '2',
          },
          {
            key: 3,
            value: '#6aad7a',
            visibility: true,
            label: '3',
          },
          {
            key: 4,
            value: '#20878c',
            visibility: true,
            label: '4',
          },
          {
            key: 5,
            value: '#295a91',
            visibility: true,
            label: '5+',
          }],
      bbspeedColorLegendData:
        [{ //#008080,#70a494,#b4c8a8,#f6edbd,#edbb8a,#de8a5a,#ca562c
            key: 0,
            value: '#ca562c',
            visibility: true,
            label: 'No Service',
          },
          {
            key: 1,
            value: '#eeaa84',
            visibility: true,
            label: '10M x 1M',
          },
          {
            key: 2,
            value: '#b4c8a8',
            visibility: true,
            label: '25M x 3M',
          },
          {
            key: 3,
            value: '#70a494',
            visibility: true,
            label: '100M x 10M',
          },
          {
            key: 4,
            value: '#008080',
            visibility: true,
            label: '1 Gbps',
          }],
    }
  },
  computed: {
    map: function () {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2VtY29nIiwiYSI6ImlvNEFUcmMifQ.VmDLZZG7l6syscFzkBs5eg'
      let style = './geojson/esri_community_vector_ago.json' //TODO: remove before going live
      return new mapboxgl.Map({
        container: this.$refs.mapgl,
        style,
        center: [-83.2437186609522, 42.454430721108764],
        zoom: 7.684440451829983,
        minZoom: 6,
        scrollZoom: true,
        dragRotate: false,
        attributionControl: false,
      }).addControl(new mapboxgl.NavigationControl(), 'top-left')
        .addControl(new mapboxgl.FullscreenControl({ container: this.$refs.mapgl }))
        .addControl(new mapboxgl.AttributionControl({
          compact: true,
        }))
        .addControl(new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          bbox: [ -85.11, 41.55, -81.46, 43.32 ],
          zoom: 10,
          collapsed: true,
          marker: true,
          flyTo: false,
          mapboxgl: mapboxgl,
          clearOnBlur: true,
          clearAndBlurOnEsc: true,
        }).on('result', (r) => {
          this.setSelectedFromGeocode(r.result.geometry.coordinates[0], r.result.geometry.coordinates[1])
        }), 'bottom-left')
    },
    mcdIds: function () {
      return Array.from(this.namesForSelectedType.keys()).sort(
        (aId, bId) => {
          let a = this.namesForSelectedType.get(aId)[0]
          let b = this.namesForSelectedType.get(bId)[0]
          return a.localeCompare(b)
        })
    },
    num_prov: function () {
      return [
        {
          type: 'raster',
          layout: {
            visibility: this.selectedLayers.fillPoly === 'num_prov_raster_0' ? 'visible' : 'none',
          },
        },
      ]
    },
    bbspeed: function () {
      let color = [
        'step',
        ['get', 'BB_CODE']]
      color.push('#ccc')
      this.bbspeedColorLegendData.forEach(c => {
        color.push(c.key, c.value)
      })
      let filter = ['in', ['get','BB_CODE'], ["literal", this.bbspeedColorLegendData.filter(c => c.visibility).map(c => c.key)]]
      return [
        {
          type: 'fill',
          filter,
          layout: {
            visibility: this.selectedLayers.fillPoly === 'bbspeed_fill_0' ? 'visible' : 'none',
          },
          paint: {
            'fill-opacity': 0.8,
            'fill-color': color,
          },
          'source-layer': 'SEM_Broadband_Simple_No_Lakes',
        },
      ]
    },
    dot_dens_race: function () {
      let color = [
        'match',
        ['get', 'race']]
      this.dotDensRaceColorLegendData.forEach(c => {
        color.push(c.key, c.value)
      })
      color.push('#ccc')/* other */

      let radius = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        11,
        1.75,
        12,
        0]

      let opacity = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0.8,
        11,
        1,
        12,
        0]

      let filter = ['in', ['get','race'], ["literal", this.dotDensRaceColorLegendData.filter(c => c.visibility).map(c => c.key)]]
      return [
        {
          type: 'circle',
          filter,
          layout: {
            visibility: this.selectedLayers.overlays === 'dot_dens_race_circle_0' ? 'visible' : 'none',
          },
          paint: {
            'circle-opacity': opacity,
            'circle-color': color,
            'circle-radius': radius,
          },
          'source-layer': 'nobb_race_dot_dens_21',
        },
      ]
    },
    dot_dens_income: function () {
      let color = [
        'match',
        ['get', 'income']]
      this.dotDensIncomeColorLegendData.forEach(c => {
        color.push(c.key, c.value)
      })
      color.push('#ccc')/* other */

      let radius = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        11,
        1.75,
        12,
        0]

      let opacity = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0.7,
        11,
        1,
        12,
        0]

      let filter = ['in', ['get', 'income'], ["literal", this.dotDensIncomeColorLegendData.filter(c => c.visibility).map(c => c.key)]]
      return [
        {
          type: 'circle',
          filter,
          layout: {
            visibility: this.selectedLayers.overlays === 'dot_dens_income_circle_0' ? 'visible' : 'none',
          },
          paint: {
            'circle-opacity': opacity,
            'circle-color': color,
            'circle-radius': radius,
          },
          'source-layer': 'nobb_income_dot_dens_21',
        },
      ]
    },
    income_per_dot: function () {
      return {
        6: '6.4',
        7: '6.3',
        8: '5.0',
        9: '3.3',
        10: '1.9',
      }[Math.floor(this.zoom)] || '1'
    },
    race_per_dot: function () {
      return {
        5: '9.7',
        6: '11.5',
        7: '11.5',
        8: '8.2',
        9: '5.1',
        10: '2.9',
        11: '1.2',
      }[Math.floor(this.zoom)] || '1'
    },
    hotspot_data: function () {
      let radius = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        12,
        22,
        20]
      let text_size = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0,
        11,
        12,
        22,
        14]
      let text_opacity = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0.8,
        22,
        1]
      return [
        {
          type: 'circle',
          layout: {
            visibility: this.hotspotVisibility ? 'visible' : 'none',
          },
          paint: {
            'circle-color': '#ff9800',
            'circle-blur': .6,
            'circle-radius': radius,
            'circle-stroke-opacity': 0.5,
            'circle-stroke-width': 1,
          },
        },
        {
          type: 'symbol',
          layout: {
            visibility: this.hotspotVisibility ? 'visible' : 'none',
            'text-field': ['get', 'LocationName'],
            'text-size': text_size,
            "text-font": ["Arial Regular"], //this is needed if using an ago vector style
          },
          paint: {
            'text-opacity': text_opacity,
            'text-halo-width': 1,
            'text-halo-color': 'white',
            'text-halo-blur': 2,
          },
        },
      ]
    },
    schools: function () {
      let radius = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        3.5,
        22,
        10]
      let text_size = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0,
        11,
        12,
        22,
        14]
      let text_opacity = [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        0.5,
        22,
        1]
      return [
        {
          type: 'circle',
          layout: {
            visibility: this.schoolsVisibility ? 'visible' : 'none',
          },
          paint: {
            'circle-color': '#0336bc',
            'circle-radius': radius,
            'circle-stroke-opacity': 0.8,
            'circle-stroke-color': '#000000',
            'circle-stroke-width': 1,
          },
        },
        {
          type: 'symbol',
          layout: {
            visibility: this.schoolsVisibility ? 'visible' : 'none',
            'text-field': ['get', 'OFFICIALNM'],
            'text-size': text_size,
            "text-font": ["Arial Regular"],//this is needed if using an ago vector style
          },
          paint: {
            'text-opacity': text_opacity,
            'text-halo-width': 1,
            'text-halo-color': 'white',
            'text-halo-blur': 1.5,
          },
        },
      ]
    },
    communitiesLayer: function () {
      let filter = ['all', ['==', 'geotype', 'BlockGroup'], ['>', 'households_21', 0]]
      let color = '#fff'
      if (this.breakPoints.length) {
        if (this.selectedLayers.fillPoly === 'blockgroups_fill_0') {
          color = ['step', ['/', ['-', ['get', 'households_21'], ['get', 'hhbroadband_21']], ['get', 'households_21']]]
        } else {
          color = ['step', ["/", ["get", "ehh_nocomputer_21"], ['get', "households_21"]]]
        }
        for (let i = 0; i < this.breakPoints.length; i += 1) {
          color.push(this.colorPalette[i], this.breakPoints[i])
        }
        color.push(this.colorPalette[this.breakPoints.length])
      }
      return [
        {
          type: 'fill',
          filter: filter,
          layout: {
            visibility: ((this.selectedLayers.fillPoly === 'blockgroups_fill_0') || (this.selectedLayers.fillPoly === 'withcomp_fill_0')) ? 'visible' : 'none',
          },
          paint: {
            'fill-color': color,
            'fill-opacity': 0.8,
          },
          'source-layer': 'BG_usage_21',
        },
        {
          type: 'line',
          filter: filter,
          layout: {
            visibility: this.selectedLayers.fillPoly === 'blockgroups_fill_0' ? 'visible' : 'none',
          },
          paint: {
            'line-color': 'white',
            'line-opacity': 0,
            'line-blur': 2,
          },
          'source-layer': 'BG_usage_21',
        },
      ]
    },
    blankGeo: function () {
      return [
        {
          type: 'fill',
          paint: {
            'fill-opacity': 0,
          },
        },
        {
          type: 'line',
          paint: {
            'line-width': this.lineWidth,
            'line-color': ['case', ['==', ['get', 'geoid'], (this.selectedId || '')], 'red', 'black'],
            'line-blur': 2,
          },
        },
      ]
    },
    lineWidth: function () {
      let width = 0;
      if (this.geotype === 'county' || this.geotype === 'mcd' || this.geotype === 'SchoolDistrict' || this.geotype === 'ISD') {
        width = 2
      } else if (this.geotype === 'CensusTract') {
        width = 1
      } else {
        width = 0.8
      }
      return ['case', ['in', ['get', 'geoid'], ['literal', [this.hoverId, this.selectedId]]], 4, width]
    },
    beforeLayers: function () {
      return ['us-congress-districts-boundary-lines', 'state-house-boundary-lines', 'state-senate-districts-boundary-lines', 'communities_line_1', 'num_prov_raster_0', 'cartography-county', 'place-village', 'mcd-pop-label-2uiaf9', 'local-dx1f7q', 'Roads by Type/Local Roads/Local Road', 'Michigan Counties', 'CommunityBoundary/label/Class 1_1', 'Railroad/casing', 'all_districts_reprojected/0']
    },
    communitiesGeoJSON: function () {
      return this.allGeojsonByType.get(this.geotype)
    },
    popupLookup: function () {
      if (!this.communitiesGeoJSON) {
        return new Map()
      }
      return new Map(this.communitiesGeoJSON.features.map(f =>
        [
          f.properties.geoid,
          [
            turf.pointOnFeature(f.geometry).geometry.coordinates,
            `<div>${f.properties['name']}</div>`,
          ],
        ],
      ))
    },
    popupData: function () {
      return this.popupLookup.get(this.hoverId || this.selectedId)
    },
    rawBreakPoints: function () {
      let raw_values
      let values
      if (this.selectedLayers.fillPoly === 'blockgroups_fill_0') {
        raw_values = Array.from(this.idsInViewport.values())
          .filter(f => (
            f &&
            f.hhbroadband_21 &&
            f.households_21
          ))
        values = raw_values
          .map(f => ((f.households_21 - f.hhbroadband_21) / f.households_21))
      } else if (this.selectedLayers.fillPoly === 'withcomp_fill_0') {
        raw_values = Array.from(this.idsInViewport.values())
          .filter(f => (
            f &&
            f.ehh_nocomputer_21 &&
            f.households_21
          ))
        values = raw_values
          .map(f => (f.ehh_nocomputer_21 / f.households_21))
      } else {
        return []
      }
      let maxvalue = Math.max(0, ...values)
      let minvalue = Math.min(Infinity, ...values)
      let count = values.length || 0
      if (count === 0 || maxvalue === 0) {
        return []
      }

      let raw = []
      let classification = this.overrideClassification;
      if (classification === 'divergingRatio') {
        raw = [
          1 - ((1 - minvalue) / 2),
          1,
          ((maxvalue - 1) / 3) + 1,
        ]
      } else if (classification === 'AreaNaturalBreaks') {
        raw = naturalBreaks(values, 4, raw_values.map(f => f['st_area(Shape)']))
      } else if (classification === 'AreaLogNaturalBreaks') {
        raw = naturalBreaks(values.map(Math.log1p), 4, raw_values.map(f => f['st_area(Shape)'])).map(Math.expm1)
      } else if (classification === 'NaturalBreaks') {
        raw = naturalBreaks(values, 4)
      } else if (classification === 'LogNaturalBreaks') {
        raw = naturalBreaks(values.map(Math.log1p), 4).map(Math.expm1)
      } else if (classification === 'AreaViewportPercentile') {
        let sorted = raw_values.sort((a, b) =>
          (a.ehhnobroadband_21) -
          (b.ehhnobroadband_21)
        )
        let cumsumAcres = sorted.map((sum => value => sum += value['st_area(Shape)'])(0))
        let totalAcres = cumsumAcres[cumsumAcres.length - 1]
        let percentiles = [0.05, 0.30, 0.70, 0.95]
        raw = percentiles.map(v => {
          let i = cumsumAcres.findIndex(s => s >= (v * totalAcres)) // TODO O(n^2)
          return sorted[i].ehhnobroadband_21
        })
      } else {
        // defeat to viewportPercentile if custom map

        let sorted = values.sort((a, b) => a - b)
        let percentiles = [0.05, 0.30, 0.70, 0.95]
        raw = percentiles.map(v => sorted[Math.floor(v * count)])
      }
      return raw
    },
    breakPoints: function () {
      let out = []
      let max = -Infinity
      this.rawBreakPoints.forEach(b => {
        if (b > max) {
          out.push(b)
          max = b
        }
      })
      return out
    },
    colorPalette: function () {
      let palette = 'Emrld'
      if (this.selectedLayers.fillPoly === 'withcomp_fill_0') {
        palette = "BrwnYl"
      }
      return cartocolor[palette][this.breakPoints.length + 1] || []
    },
    dotDensIncomelegendMarks: function () {
      return ['$0', '$20k', '$35k', '$50k', '$75k', 'Inf']
    },
    colorLegendData: function () {
      let out = []
      for (let i = 0; i <= this.breakPoints.length; i += 1) {
        out.push(
          {
            key: [
              this.breakPoints[i - 1] || -Infinity,
              this.breakPoints[i] || Infinity,
            ],
            value: this.colorPalette[i],
          }
        )
      }
      return out
    },
    popup: function () {

      let markerHeight = 20, markerRadius = 5, linearOffset = 5;
      let popupOffsets = {
        'top': [0, 0],
        'top-left': [0, 0],
        'top-right': [0, 0],
        'bottom': [0, -markerHeight],
        'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
        'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
        'left': [markerRadius, (markerHeight - markerRadius) * -1],
        'right': [-markerRadius, (markerHeight - markerRadius) * -1],
      }

      return new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        offset: popupOffsets,
      })
    },
    format: function () {
      return d3.format('.2f')
    },
    formatCommas: function () {
      return d3.format(',d')
    },
    legendMarks: function () {
      if (!this.colorLegendData) {
        return []
      }
      let d = [0].concat(this.colorLegendData.map(legend => legend.key[1]).filter(isFinite)).concat([1.0])
      return Array.from(new Set(d))
    },
  },
  methods: {
    setHover: debounce(function (id) {
      if (this.mouseover || !id) {
        if (this.hoverId !== id) {
          this.$emit('set-hov-geom-id', id)
        }
      }
    }, 100),
    setGeoType: function (id) {
      this.$emit('set-geo-type', id)
    },
    setSelectedtoRegion: function () {
      this.setSelected(8999)
      this.zoomTo(8999)
    },
    setSelected: function (id) {
      this.$emit('set-sel-geom-id', id)
    },
    communityClick: function (featureEvent) {
      if (featureEvent.features.length > 0) {
        const feature = featureEvent.features[0]
        this.$emit('set-sel-geom-id', feature.properties.geoid)
      }
    },
    setLegendFilter: function (legend, category) {
      this[legend].forEach(l => {
        if (l.key === category) {
          l.visibility = !l.visibility
        }
      })
    },
    communityHover: function (featureEvent) {
      if (featureEvent.features.length > 0) {
        const feature = featureEvent.features[0]
        this.setHover(feature.properties.geoid)
      } else {
        this.setHover(null)
      }
    },
    formatOnLegend: d3.format('.2f'),
    formatPercentOnLegend: d3.format('.00%'),
    setMapStyle: function (e) {
      this.map.setStyle(e)
    },
    setStyle: debounce(function () {
      if (this.map.getLayer('communities_line_1')) {
        this.$nextTick(() => {
          this.loaded = true
        })
      }

      if (!this.map.getLayer('blockgroups_fill_0')) {
        return
      }

      let features = this.map.queryRenderedFeatures({layers: ['blockgroups_fill_0']});
      // queryRenderedFeatures can return duplicates so filter them out
      features = Object.freeze(new Map(features.map(f => [f.properties.geoid, f.properties] )));
      if (
        features.size > 0 && (
          features.size !== this.idsInViewport.size ||
          Array.from(features.keys()).some(id => !this.idsInViewport.has(id))
        )
      ) {
        this.idsInViewport = features
      }
    }, 150, { leading: true, maxWait: 600 }),
    zoomTo: function (id) {
      if (!this.communitiesGeoJSON || !this.autoZoom) {
        return
      }
      let extent = {
        93: [[-84.2579218629181, 42.3239034763136], [-83.564870927822, 42.8832526817047]],
        99: [[-83.202747340568, 42.3471894195991], [-82.6063045158249, 42.9974602667658]],
        115: [[-83.87391435586, 41.6235951031165], [-83.0785807251129, 42.1942805362744]],
        125: [[-83.7894115599797, 42.3312327335914], [-82.9834924191637, 42.9886278835273]],
        147: [[-83.0960949946948, 42.418557292642], [-82.3184528982991, 43.2688321383929]],
        161: [[-84.2340738132845, 41.9715949343173], [-83.4394579054165, 42.5351067992344]],
        163: [[-83.6516108768434, 41.9331541851303], [-82.7701109750752, 42.5510028516089]],
      }[id]
      if (!extent) {
        let geo = this.communitiesGeoJSON.features.find(geo => geo.properties.geoid === id)
        if (geo) {
          let bbox = turf.bbox(turf.buffer(
            turf.bboxPolygon(turf.bbox(geo)),
            17 + 0.0000004 * Math.sqrt(geo.properties.acres || 0), //TODO: tune to match existing behaviour
            { units: 'kilometers', steps: 4 },
          ))
          extent = [[bbox[0], bbox[1]], [bbox[2], bbox[3]]]
        }
      }
      if (!extent) {
        extent = [[-84.26761319266765, 41.70537147789608], [-82.21982412924997, 43.215991926555176]]
      }
      this.map.fitBounds(
        extent,
        { padding: 1 },
      )
    },
    setSelectedFromGeocode: function (x, y) {
      if (!this.map.getLayer('communities_fill_0')) {
        return
      }
      let features = this.map.queryRenderedFeatures(this.map.project([x, y]), { layers: ['communities_fill_0'] });
      if (features.length) {
        this.setSelected(features[0].properties.geoid)
      }
    },
    tooltipFormat: function (properties) {
      let noom = properties.NoInternet
      let noomMoe = properties[this.getIndMoeName('NoInternet')] || 0
      if (noomMoe === 0) {
        return '<strong>' + this.format(noom) + '</strong>'
      } else {
        return '<strong>' + this.format(noom) + '</strong><small> +/- ' + this.format(noomMoe) + '</small>'
      }
    },
  },
  mounted: function () {
    this.$once('hook:beforeDestroy', function () {
      this.map.remove()
    })
    this.map.once('idle', () => {
      this.setStyle();
      this.zoomTo(this.selectedId)
      this.map.on('sourcedata', (e) => {
        if (e.sourceId === 'blockgroups') {
          this.setStyle();
        }
      });
      this.map.on('zoomend', () => {
        this.zoom = this.map.getZoom();
      })
    });
  },
  watch: {
    selectedId: function () {
      this.zoomTo(this.selectedId)
    },
    popupData: function () {
      let data = this.popupData
      if (data) {
        this.popup.setLngLat(data[0])
        this.popup.setHTML(data[1])
        this.popup.addTo(this.map)
      } else {
        this.popup.remove()
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only. /deep/ applies to children as well -->
<style scoped>
  select {
    min-width: 0;
  }

  #map {
    display: grid;
    grid-template-rows: max-content auto;
    grid-column: 2;
    grid-row: 2;
    position: relative;
  }

  /deep/ .mapboxgl-map {
    width: 100%;
    height: 100%;
  }

  .controls {
    background-color: #ffffff;
    padding: 5px;
    display: grid;
    grid-template-columns: 40% 60%;
    margin: 2px;
    border: solid 2px #000000;
    border-radius: 10px;
  }

  .comm_dropdown {
    max-width: 75%;
  }

  .layer_dropdown {
    max-width: calc(100% - 20px);
  }

  .layer_dropdown, .comm_dropdown {
    border-bottom: solid black 2px;
    border-top: solid black 0;
    border-left: solid black 0;
    border-right: solid black 0;
  }

  .layer_dropdown:focus, .comm_dropdown:focus {
    outline: 0;
    border-color: black;
  }

  .layer_dropdown option, .comm_dropdown option {
    font-size: 0.8rem;
  }

  .mapboxgl-ctrl-top-right {
    max-width: calc(100% - 50px);
  }

  #basemap {
    pointer-events: auto;
    position: absolute;
    grid-row: 2;
  }

  .mapboxgl-ctrl-top-right > div.basemaps {
    background-color: white;
    opacity: 0.9;
    padding: 0;
    margin: 50px 10px 0 0;
    pointer-events: auto;
    border-radius: 2px;
  }

  .mapboxgl-ctrl-top-left {
    position: inherit;
    max-width: 100%;
    pointer-events: auto;
  }

  .mapboxgl-ctrl-top-left>div.name {
    margin: 0;
    border-radius: 0;
    background-color: white;
    opacity: 0.9;
    padding: 4px;
    pointer-events: auto;
  }

  .mapboxgl-ctrl-bottom-right {
    max-width: calc(100% - 250px);
  }

  .map_layers {
    display: grid;
    grid-template-columns: 1fr 1fr 10%;
    font-size: small;
    grid-gap: 3px;
    margin: 3px;
  }

  .map_layers>div{
    grid-gap: 3px;
    min-width: 0;
  }

  #homeExtent {
    pointer-events: auto;
    position: absolute;
    margin: 110px 0 10px 10px;
    grid-row: 2;
  }

    #AutoZoom {
    pointer-events: auto;
    position: absolute;
    margin: 150px 0 10px 10px;
    grid-row: 2;
  }

  /deep/ .subgroup {
    margin-left: 15px;
  }

  /deep/ .mapboxgl-popup {
    display: block !important;
    z-index: 1;
    pointer-events: none !important;
  }

  /deep/ .mapboxgl-popup strong {
    font-size: medium;
  }

  /deep/ .mapboxgl-popup small {
    color: #9aa5a9;
    font-size: small;
  }

  /deep/ .mapboxgl-popup .mapboxgl-popup-content {
    background: #292424;
    color: white;
    opacity: 0.95;
    border-radius: 16px;
    padding: 5px 10px 4px;
    pointer-events: none !important;
  }

  /deep/ .mapboxgl-popup .mapboxgl-popup-tip {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #292424;
    opacity: 0.8;
    z-index: 1;
  }

  /deep/ .mapboxgl-popup {
    margin-bottom: 10px;
  }

  /deep/ .mapboxgl-popup .mapboxgl-popup-tip {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }

  @media (max-width: 1300px) {
    #map {
      display: grid;
      grid-template-rows: max-content auto;
    }

    .mapboxgl-ctrl-top-left {
      position: inherit;
      max-width: 100%;
    }

    #homeExtent {
      margin: 110px 0 10px 10px;
      grid-row: 2;
    }

    #AutoZoom {
      margin: 150px 0 10px 10px;
      grid-row: 2;
    }

    #basemap {
      pointer-events: auto;
      position: absolute;
      grid-row: 2;
    }

    .mapboxgl-ctrl-top-left>div.name {
      margin: 0;
      border-radius: 0;
    }
  }

  @media (max-width: 1000px) {
    .mapboxgl-ctrl-top-left>div.name {
      padding: 10px 10px 5px;
    }
  }

  @media (max-width: 576px), print {
    #map {
      height: 120vh;
      grid-row: 2;
      grid-column: 1;
    }
  }
</style>
